import type { RecursiveRequired, Settings } from '#/global'
import settingsDefault from '@/settings.default'
import { merge } from '@/utils/object'
import { cloneDeep } from 'es-toolkit'

const globalSettings: Settings.all = {
  app: {
    lightTheme: 'blue',
    darkTheme: 'blue',
  },
  menu: {
    mode: 'single',
    mainMenuClickMode: 'smart',
  },
  topbar: {
    mode: 'fixed',
  },
  toolbar: {
    navSearch: false,
    i18n: true,
    pageReload: true,
  },
}

export default merge(globalSettings, cloneDeep(settingsDefault)) as RecursiveRequired<Settings.all>
